<template>
<div class="container card mt-4 speakers-register-card">
    <div class="card-header text-center">
        <i class="fas fa-user-plus fa-3x text-primary mb-3"></i>
        <h2 class="text-muted mb-1">Credenciamento de Palestrante</h2>
        <p class="text-muted mb-0">
            Preencha as informações abaixo para submeter sua proposta de palestra.
        </p>
    </div>

    <form role="form" class="mt-3" autocomplete="off">
        <h3 class="px-3 subtitle font-weight-bold text-primary mb-2">Informações Pessoais</h3>

        <base-input
            v-model="model.name"
            v-validate="'required'"
            name="Nome"
            class="mb-3 px-3"
            placeholder="Nome Completo"
            prepend-icon="ni ni-circle-08"
            :error="errors.first('Nome')"
        />
        <base-input
            v-model="model.email"
            v-validate="'required|email'"
            name="E-mail"
            class="mb-3 px-3"
            placeholder="E-mail"
            prepend-icon="ni ni-email-83"
            :error="errors.first('E-mail')"
        />

        <div class="px-3 d-flex flex-wrap">
            <base-input
                class="col-12 col-md-6 pl-0 pr-md-2"
                v-model="model.password"
                v-validate="{ required: true, min: 6 }"
                name="Senha"
                type="password"
                placeholder="Senha"
                prepend-icon="ni ni-lock-circle-open"
                :error="errors.first('Senha')"
            />
            <base-input
                class="col-12 col-md-6 pr-0 pl-md-2"
                v-model="model.password_confirmation"
                v-validate="{ is: model.password, required: true, min: 6 }"
                name="Confirmar Senha"
                type="password"
                placeholder="Confirmar Senha"
                prepend-icon="ni ni-lock-circle-open"
                :error="errors.first('Confirmar Senha')"
            />
        </div>

        <!-- Documento (CPF etc) e campos customizados do cadastro de aluno -->
        <document-input
            class="px-3"
            ref="doc_form"
            v-model="model"
            :required="false"
        />
        <form-builder ref="builder_form" v-model="formBuilder" />
        <address-form
            class="px-3"
            v-if="enableAddresses"
            ref="address_form"
            v-model="address"
        />

        <h3 class="px-3 subtitle font-weight-bold text-primary mt-3 mb-2">
            Perfil Profissional &amp; Acadêmico
        </h3>

        <base-input
            v-model="model.credentials"
            name="Credenciais"
            class="mb-3 px-3"
            placeholder="Credenciais / Mini Currículo (Ex: Doutor em Educação)"
            prepend-icon="ni ni-badge"
        />

        <div class="px-3 mb-3">
            <textarea
                v-model="model.themes"
                class="form-control"
                rows="3"
                placeholder="Temas de Interesse para Palestra"
            ></textarea>
        </div>

        <base-input
            v-model="model.lattes"
            v-validate="'url'"
            name="Portfólio / Currículo"
            class="mb-3 px-3"
            placeholder="Link do Portfólio / Currículo"
            prepend-icon="ni ni-hat-3"
            :error="errors.first('Portfólio / Currículo')"
        />
        <base-input
            v-model="model.linkedin"
            v-validate="'url'"
            name="LinkedIn"
            class="mb-3 px-3"
            placeholder="LinkedIn (https://linkedin.com/in/...)"
            prepend-icon="ni ni-world"
            :error="errors.first('LinkedIn')"
        />

        <div class="px-3 d-flex justify-content-between align-items-center pb-4">
            <a href="/speakers" class="btn btn-link text-muted">Cancelar</a>
            <base-button
                @click.stop="submit"
                :loading="loading"
                type="success"
            >Submeter Inscrição</base-button>
        </div>
    </form>
</div>
</template>

<script>
import BaseInput from '@web/argon/components/Inputs/BaseInput';
import BaseButton from '@web/argon/components/BaseButton';
import FormBuilder from '@web/components/FormBuilderComponents/FormBuilder';
import DocumentInput from '@web/components/Common/DocumentInput';
import AddressForm from '@web/components/FormBuilderComponents/ContentComponents/AddressForm';

export default {
    name: 'SpeakersRegister',
    components: {
        BaseInput,
        BaseButton,
        FormBuilder,
        DocumentInput,
        AddressForm,
    },
    props: {
        studentForm: {
            type: Object,
            required: false,
            default: null,
        },
    },
    data() {
        return {
            loading: false,
            formBuilder: this.studentForm || { fields: [] },
            model: {
                name: '',
                email: '',
                password: '',
                password_confirmation: '',
                credentials: '',
                themes: '',
                lattes: '',
                linkedin: '',
                document: '',
                document_type: '',
            },
            address: {
                location: {
                    zip: '',
                    address: '',
                    number: '',
                    neighborhood: '',
                    country: '',
                    state: '',
                    city: '',
                    info: '',
                    code: 'BR',
                },
            },
        };
    },
    computed: {
        enableAddresses() {
            return !!(this.studentForm && this.studentForm.enable_addresses);
        },
        hasCustomFields() {
            return !!(this.formBuilder && this.formBuilder.fields && this.formBuilder.fields.length);
        },
    },
    methods: {
        async submit() {
            // Valida o form principal (vee-validate deste componente)
            const selfValid = await this.$validator.validate();

            // Valida componentes filhos (form-builder, documento, endereço)
            const childRefs = ['builder_form', 'doc_form', 'address_form'];
            const childResults = await Promise.all(
                childRefs
                    .map(r => this.$refs[r])
                    .filter(c => c && c.$validator)
                    .map(c => c.$validator.validate())
            );
            const childrenValid = childResults.every(Boolean);

            if (!selfValid || !childrenValid) return;

            this.loading = true;
            const payload = { ...this.model };
            if (this.hasCustomFields) {
                payload.form = { ...this.formBuilder };
            }
            if (this.enableAddresses) {
                payload.address = { ...this.address };
            }

            window.axios.post('/api/public/speakers/register', payload)
                .then((response) => {
                    this.$notify({
                        type: 'success',
                        message: response.data.message || 'Inscrição realizada com sucesso!',
                    });
                    setTimeout(() => { window.location.href = '/speakers'; }, 2000);
                })
                .catch((error) => {
                    let errMsg = 'Ocorreu um erro ao submeter a inscrição.';
                    if (error.response && error.response.data && error.response.data.error) {
                        errMsg = error.response.data.error;
                    } else if (error.response && error.response.data && error.response.data.errors) {
                        const first = Object.values(error.response.data.errors)[0];
                        errMsg = Array.isArray(first) ? first[0] : first;
                    }
                    this.$notify({ type: 'danger', message: errMsg });
                })
                .finally(() => { this.loading = false; });
        },
    },
};
</script>

<style scoped>
.speakers-register-card {
    max-width: 800px;
    margin-left: auto;
    margin-right: auto;
    border-radius: 12px;
}
.subtitle {
    font-size: 1.05rem;
}
</style>
